import type { FeatureGroup } from '../../types';

export const ADMINISTRATIVE_FEATURE_GROUP: FeatureGroup = {
  guid: '495dc8af-cdb1-4d52-9847-411a00635d70',
  name: 'administrative',
  description: 'Root group for all administrative features — account, team, roles, domains, etc.',
  product: 'account',
};
